import React, { useState } from 'react';
import { TextField, InputAdornment, FormHelperText } from '@mui/material';

export const RateField = ({ 
  label, 
  value, 
  onChange, 
  minValue = 0, 
  helperText,
  ...props 
}) => {
  const [error, setError] = useState('');
  
  const handleChange = (e) => {
    let val = e.target.value;
    
    // Allow empty string
    if (val === '') {
      onChange('');
      setError('');
      return;
    }
    
    // Remove any non-numeric characters except decimal point
    val = val.replace(/[^0-9.]/g, '');
    
    // Ensure only one decimal point
    const parts = val.split('.');
    if (parts.length > 2) {
      val = parts[0] + '.' + parts.slice(1).join('');
    }
    
    // Limit to 2 decimal places
    if (parts[1] && parts[1].length > 2) {
      val = parts[0] + '.' + parts[1].slice(0, 2);
    }
    
    // Validate minimum value
    const numValue = parseFloat(val);
    if (!isNaN(numValue) && numValue < minValue) {
      setError(`Minimum rate is $${minValue.toFixed(2)}`);
    } else {
      setError('');
    }
    
    onChange(val);
  };
  
  const handleBlur = () => {
    if (value && value !== '') {
      const numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        // Format to 2 decimal places on blur
        onChange(numValue.toFixed(2));
      }
    }
  };
  
  return (
    <TextField
      {...props}
      label={label}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={!!error}
      helperText={error || helperText || `Minimum: $${minValue.toFixed(2)}`}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      }}
      placeholder="0.00"
    />
  );
};